// 在组件中使用 http.js

import http from "../utils/http";

const apiService = {
  // 验证码测试
  smspost(params) {
    return http.post("/pos-system/v1/notice/sms/mp", params);
  },

  // 运单列表
  parcelList(params) {
    return http.post(
      "/admin-api/express/track/getOfficialWebsiteTrack",
      params
    );
  },

  // 查询官网新闻分页
  newsList(params) {
    return http.get(
      `/admin-api/express/news/website-page?pageNo=${params.pageNo}&pageSize=${
        params.pageSize
      }&newsType=${params.newsType}`
    );
  },

  // 查询官网新闻详情
  newsInfo(id) {
    return http.get(`/admin-api/express/news/website-get?id=` + id);
  },
};

export default apiService;
